module.exports = __webpack_public_path__ + "static/media/templateinactive.94afb127.svg";